import type { PlanFeatureName } from "@repo/app-types/helpers/billingFeatureGating";
import { Modal } from "@repo/ui/Modal/modal";
import { ModalHeader } from "@repo/ui/Modal/modalHeader";
import { type FC, useState } from "react";
import { UpsellBanner } from "./upsellBanner.js";

interface UpgradeTextProps {
  planFeatureName: PlanFeatureName;
}

export const UpgradeText: FC<UpgradeTextProps> = ({ planFeatureName }) => {
  const [shouldShowUpsellBanner, setShouldShowUpsellBanner] = useState(false);

  return (
    <>
      <span
        className="cursor-pointer font-medium text-blue-600 hover:text-blue-500"
        onClick={() => setShouldShowUpsellBanner(true)}
      >
        {" "}
        Upgrade to access.
      </span>
      <Modal
        isOpen={shouldShowUpsellBanner}
        onCancel={() => setShouldShowUpsellBanner(false)}
      >
        <ModalHeader onClose={() => setShouldShowUpsellBanner(false)}>
          Upgrade for access
        </ModalHeader>
        <div className="mt-6">
          <UpsellBanner planFeatureName={planFeatureName} />
        </div>
      </Modal>
    </>
  );
};
